import { authenticatedApiFetch } from '../utils/utils'

export const allEvaluationsForClassService = async (classId) => {
    if (!classId) {
        return []
    }
    const res = await authenticatedApiFetch(`/evaluations/?classes=${classId}&all`, { method: 'GET' })
        .then(response => response.json())
        .catch(error => {
            console.error(error)
            return []
        })
    return Array.isArray(res) ? res : (res?.results ?? [])
}
